import React from 'react';
import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseDocumentSelect, type BaseDocumentSelectInputProps } from './BaseDocumentSelect';

export type DocumentSelectProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseDocumentSelectInputProps,
	'error' | 'onChange' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

export function DocumentSelect<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: DocumentSelectProps<T, FP>) {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseDocumentSelect error={error} value={value} onChange={onChange} {...props} />;
}
